// extracted by mini-css-extract-plugin
export var header = "layout-module--header--1SL-G";
export var wrapper = "layout-module--wrapper--fnmu-";
export var activeM = "layout-module--active-m--OHv-J";